export default function filterInvalidRecipients(originalList) {
    return originalList.filter(function (wrapper) {
        return !!wrapper.EmailAddress;
    });
}
//# sourceMappingURL=filterInvalidRecipients.js.map